export enum BmReportsConsHistoryMessages {
  MARK_COMPLETE_LABEL = 'Mark as completed',
  MARK_NOT_COMPLETE_LABEL = 'Mark as not completed',
  MARK_ALL_COMPLETE_LABEL = 'Mark as all completed',
  ARCHIVE_LABEL = 'Archive',
  DELETE_LABEL = 'Delete',
}
